<template>
  <div>
    <div class="title"> 打开手机微信扫码登录 </div>
    <div class="wx-box m-b-20" >
      <wechartQR id="login_container" redirect-path="/wxlogin"/>
    </div>
    <div class="primary-btn" @click="goLogin">使用账号登录</div>
  </div>
</template>

<script>
import wechartQR from '../../components/wechartQR.vue'
export default {
  data() {
    return {}
  },
  components: {wechartQR},
  created() {
    const route = this.$route;
    const code = route.query.code;
    if (code){
      this.getLogin(code)
    }
  },
  methods: {
    goLogin () {
      this.$router.push({
          path:'/login'
      })
    },
    getLogin (code) {
      this.axios.post('/wapi/pc/login', {
        code
      }).then(res => {
        this.getCompany()
      })
    },
    getCompany(){
        this.axios.get("/wapi/hr/listCompany").then(res =>{
            if(res.status*1 == 200){
                if(res.data.length == 0){
                    this.$router.push({path:'/register/join'});
                }else{
                    this.$router.push({path:"/login/select"});
                }
            }
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../assets/less/login.less');
.wx-box{
  height: 200px;
  width: @content-width;
}
.title{
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// wechatLogin.vue?6bc09204